module.exports = __webpack_public_path__ + "static/media/tick.59c1d204.svg";